//
// ============================================================================
// ERROR MAPPING UTILITY
// ============================================================================
//

/**
 * Map API errors to user-friendly messages
 *
 * Handles common error scenarios:
 * - Network errors (CORS, failed to fetch)
 * - Server errors (500)
 * - Unknown errors (fallback)
 *
 * @param error - Error string from API (can be null)
 * @param t - Translation function from i18n
 * @returns Object with title and message for display
 */
export function mapApiError(error: string | null, t: (key: string) => string): { title: string; message: string } {
  // No error - return generic loading error
  if (!error) {
    return {
      title: t("pages.validation.samples.errorLoading"),
      message: t("pages.validation.results.pending.errors.pleaseTryAgain"),
    };
  }

  // Network errors (CORS, connection issues)
  if (error.includes("CORS") || error.includes("Failed to fetch")) {
    return {
      title: t("pages.validation.results.pending.errors.networkError"),
      message: t("pages.validation.results.pending.errors.pleaseTryAgain"),
    };
  }

  // Server errors (500)
  if (error.includes("500")) {
    return {
      title: t("pages.validation.results.pending.errors.serverError"),
      message: t("pages.validation.results.pending.errors.pleaseTryAgain"),
    };
  }

  // Unknown error - return raw error message
  return {
    title: t("pages.validation.samples.errorLoading"),
    message: error,
  };
}
